import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Text } from 'react-native';

export const MapMarker = ({ coordinate, title, description, iconEmoji, ...props }: any) => {
  if (typeof window === 'undefined') return null;
  
  const L = require('leaflet');
  const { Marker: LMarker, Popup } = require('react-leaflet');

  const customIcon = L.divIcon({
    className: 'custom-map-marker',
    html: `<div style="display: flex; align-items: center; justify-content: center; font-size: 28px; text-shadow: 0px 2px 4px rgba(0,0,0,0.5);">${iconEmoji || '📍'}</div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    popupAnchor: [0, -15]
  });

  return (
    <LMarker position={[coordinate.latitude, coordinate.longitude]} icon={customIcon}>
      {(title || description) && (
        <Popup>
          <div style={{ fontWeight: 'bold' }}>{title}</div>
          <div>{description}</div>
        </Popup>
      )}
    </LMarker>
  );
};

export const MapPolyline = ({ coordinates, strokeColor, strokeWidth }: any) => {
  if (typeof window === 'undefined') return null;
  const { Polyline } = require('react-leaflet');
  
  // Transform from {latitude, longitude} to [lat, lng] for Leaflet
  const positions = coordinates.map((c: any) => [c.latitude, c.longitude]);
  
  return (
    <Polyline 
      positions={positions}
      pathOptions={{ color: strokeColor || '#007AFF', weight: strokeWidth || 4 }}
    />
  );
};

export default function MapView({ style, initialRegion, children, ...props }: any) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsMounted(true), 0);
    return () => clearTimeout(timer);
  }, []);

  if (!isMounted || typeof window === 'undefined') {
    return (
      <View style={[style, styles.container, { backgroundColor: '#e5e5ea', alignItems: 'center', justifyContent: 'center' }]}>
        <Text style={{ color: '#8e8e93', fontSize: 16 }}>🗺️ Cargando Mapa...</Text>
      </View>
    );
  }

  const L = require('leaflet');
  if (typeof document !== 'undefined') {
    if (!document.getElementById('leaflet-css')) {
      const link = document.createElement('link');
      link.id = 'leaflet-css';
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);
    }
  }
  const { MapContainer, TileLayer } = require('react-leaflet');

  // Ignorar error de iconos por defecto de Leaflet
  if (L.Icon && L.Icon.Default && L.Icon.Default.prototype) {
    delete (L.Icon.Default.prototype as any)._getIconUrl;
  }

  const center = initialRegion 
    ? [initialRegion.latitude, initialRegion.longitude] 
    : [18.4861, -69.9312];

  // Si pasamos un estilo custom (ej. array), podemos inferir que es modo noche/premium
  const isDarkMode = props.customMapStyle && Array.isArray(props.customMapStyle);
  const tileUrl = isDarkMode 
    ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" // Dark theme CartoDB
    : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

  return (
    <View style={[style, styles.container]}>
      <MapContainer 
        center={center as any} 
        zoom={14} 
        scrollWheelZoom={true} 
        style={{ height: '100%', width: '100%', zIndex: 0 }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url={tileUrl}
        />
        {children}
      </MapContainer>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  }
});
